import axios from 'axios'
import type { CompleteLoginResponseData, LoginPayload } from '@/types/api/auth'

const BASE_PATH = '/auth'

export const loginApiCall = async (
  abortController?: AbortController,
  params?: LoginPayload,
): Promise<CompleteLoginResponseData> => {
  const { data } = await axios.post(
    `${BASE_PATH}/login`,
    {
      ...params,
    },
    { signal: abortController?.signal },
  )
  return data.data
}

const refreshClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

export const refreshApiCall = async (tokenHeader: string): Promise<CompleteLoginResponseData> => {
  console.log(tokenHeader)
  const { data } = await refreshClient.post(`${BASE_PATH}/refresh`, null, {
    headers: {
      Authorization: tokenHeader,
    },
  })
  return data.data
}

export const logoutApiCall = async (abortController?: AbortController) => {
  const { data } = await axios.post(`${BASE_PATH}/logout`, null, {
    signal: abortController?.signal,
  })
  return data
}
